export default "__VITE_ASSET__33d80381__"